export const actionTypes = {
	SetAmbassadors: '[Ambassador] SetAmbassadors',
	SetAmbassador: '[Ambassador] SetAmbassador',
};

export const init = {
	ambassadors: [],
};

export const reducer = (state = init, { type, payload }) => {
	switch (type) {
		case actionTypes.SetAmbassadors:
			return {
				...state,
				ambassadors: payload,
			};
		case actionTypes.SetAmbassador:
			return {
				...state,
				ambassadors: state.ambassadors.map(ambassador =>
					ambassador._id === payload._id ? payload : ambassador,
				),
			};
		default:
			return state;
	}
};

export const actions = {
	SetAmbassadors: payload => ({ type: actionTypes.SetAmbassadors, payload }),
	SetAmbassador: payload => ({ type: actionTypes.SetAmbassador, payload }),
};

export function* saga() {}
